import React, { useState, useContext } from "react";
import { resetPassword } from "../Api/Password";
import { useHistory } from "react-router-dom";
import Input from "../Components/Input";
import Button from "../Components/Button";
import useQuery from "../hooks/useQuery";
import { LoginContext } from "./LoginContextProvider";

const ResetPassword = () => {
  const history = useHistory();
  const [showError, setShowError] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const { setPasswordIsReset } = useContext(LoginContext);

  let query = useQuery();

  const [data, setData] = useState({
    reset_password_token: `${query.get("reset_password_token")}`,
    email: null,
    password: "",
    password_confirmation: "",
  });

  const handleChange = ({ target: { name, value } }) => {
    setData({ ...data, [name]: value });
    setShowError(false);
  };

  const isPasswordValid = () => {
    const passwordLength = data.password.length;
    return passwordLength >= 12 && passwordLength <= 256;
  };

  const doPasswordsMatch = () => {
    return data.password === data.password_confirmation;
  };

  const isFormValid = () => {
    return (
      data.password &&
      data.password_confirmation &&
      isPasswordValid() &&
      doPasswordsMatch()
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isFormValid()) {
      setShowError(true);
    } else {
      setIsFetching(true);
      resetPassword(data);
      setData({
        reset_password_token: "",
        email: null,
        password: "",
        password_confirmation: "",
      });
      setPasswordIsReset(true);
      history.push("/");
    }
  };

  return (
    <div className="flex justify-center h-full bg-white">
      <div className="w-1/2 flex justify-center items-center">
        <div className="flex flex-col items-stretch">
          <div className="text-center text-5xl mb-2">Password Reset</div>
          <form id="submit" onSubmit={handleSubmit}>
            <Input
              type="password"
              label="New Password"
              value={data.password}
              name="password"
              onChange={handleChange}
              disabled={isFetching}
              required
            />
            <div className="py-2"></div>
            <Input
              type="password"
              label="Password Confirmation"
              value={data.password_confirmation}
              name="password_confirmation"
              onChange={handleChange}
              disabled={isFetching}
              required
            />
            <div className="py-2"></div>
            {showError && !doPasswordsMatch() && (
              <div className="text-red-500 mt-4">
                The passwords do not match
              </div>
            )}
            {showError && !isPasswordValid() && data.password && (
              <div className="text-red-500 mt-4">
                Password must be between 12 and 256 characters
              </div>
            )}
            <Button
              text={isFetching ? `Loading ${"\u00A0"}` : "Submit"}
              type="submit"
              form="submit"
              value="Submit"
              disabled={isFetching}
              inProgress={isFetching}
              className="button button-lg"
            ></Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
